import PropTypes from "prop-types";
import RadioButton from "@shared/v2/RadioButton";
import { incomeBtnHandlr, expenseBtnHandlr } from "./handlers";

const IncomeExpenseRadio = ({ modalThis, setExpenseValue }) => (
  <div className="tw-flex tw-gap-[16px]">
    <RadioButton
      label="Income"
      selected={modalThis.state.type === "revenue"}
      name="type"
      value="revenue"
      onChange={(e) => incomeBtnHandlr(e, modalThis)}
      checked={modalThis.state.type === "revenue"}
    />
    <RadioButton
      label="Expense"
      selected={modalThis.state.type === "expense"}
      name="type"
      value="expense"
      onChange={(e) => expenseBtnHandlr(e, modalThis, setExpenseValue)}
      checked={modalThis.state.type === "expense"}
    />
  </div>
);

IncomeExpenseRadio.propTypes = {
  modalThis: PropTypes.shape().isRequired,
  setExpenseValue: PropTypes.func.isRequired,
};

export default IncomeExpenseRadio;
export { IncomeExpenseRadio };
